// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-checkout__bonus',
    // #endregion
    // #region Events
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        cart: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        status: {
            type: Object,
            required: true,
            default: {}
        }
    },
    // #endregion
    // #region Methods
    methods: {
        async selectBonus(item) {
            // #region Set
            this.data.bonus = [];
            // #endregion
            // #region Append
            this.data.bonus.push({ name: item.name });
            // #endregion
        },
        isItemSelect(item) {
            // #region Vars
            if (!this.data.bonus) {
                return false;
            }
            // #endregion
            return this.data.bonus.some(e => e.name === item.name);
        },
        async showDetails(item) {
            if (!item?.itemNumber) {
                return;
            }
            await this.$host.notification.showModal2(this.$host.components.getComponent("g-product-modal"), { productNumber: item.itemNumber }, { variant: "slide", position: "bottom", size: "large" });
        }
    }
    // #endregion
});
// #endregion
